<template>
  <el-dialog title="详情" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <el-descriptions title="" :column="3">
        <el-descriptions-item label="分类：">{{formData.category_str}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{formData.create_time}}</el-descriptions-item>

      </el-descriptions>

      <div class="d-s-s d-c" v-if="formData.type == 60 || formData.type == 70">
        <div>
          <el-descriptions title="" direction="vertical" :column="10" border>
            <el-descriptions-item label="得分">{{formData.score}}</el-descriptions-item>
            <el-descriptions-item label="正确率(%)">{{formData.accuracy}}</el-descriptions-item>
            <el-descriptions-item label="用时">{{formData.use_time}}</el-descriptions-item>
            <el-descriptions-item label="满分">{{formData.full_score}}</el-descriptions-item>
            <el-descriptions-item label="及格">{{formData.pass_score}}</el-descriptions-item>
            <el-descriptions-item label="时限(分钟)">{{formData.valid_minute}}</el-descriptions-item>
          </el-descriptions>
        </div>
        <div>
          <el-table class="custom mt10" :data="formData.statistics" border stripe v-if="formData.statistics">
            <el-table-column prop="name" label="题型" width="80" align="center"></el-table-column>
            <el-table-column prop="right_count" label="答对题数" width="80" align="center"></el-table-column>
            <el-table-column prop="total" label="答题数" width="80" align="center"></el-table-column>
            <el-table-column prop="score" label="得分" width="80" align="center"></el-table-column>
          </el-table>
        </div>
      </div>
      
      <!-- 刷题计划 -->
      <div class="d-s-s d-r tc" v-if="[10,11,12,13,14].indexOf(formData.type) !== -1">
        <el-descriptions title="" direction="vertical" :column="10" border>
          <el-descriptions-item label="总题数">{{formData.question_ids.length}}</el-descriptions-item>
          <el-descriptions-item label="每日任务数" v-if="formData.type == 14">{{formData.daily_task_count}}</el-descriptions-item>
          <el-descriptions-item label="完成总天数" v-if="formData.type == 14">{{formData.complete_day}}</el-descriptions-item>
          <el-descriptions-item label="正确率(%)">{{formData.accuracy}}</el-descriptions-item>
          <el-descriptions-item :label="v.name" v-for="(v, i) in answerType" :key="i">{{shuatiPlanCount[v.value].right+'/'+shuatiPlanCount[v.value].count}}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 背诵计划 -->
      <div class="d-s-s d-r tc" v-if="[20,21].indexOf(formData.type) !== -1">
        <el-descriptions title="" direction="vertical" :column="10" border>
          <el-descriptions-item label="总题数">{{formData.question_ids.length}}</el-descriptions-item>
          <el-descriptions-item label="每日任务数" v-if="formData.type == 21">{{formData.daily_task_count}}</el-descriptions-item>
          <el-descriptions-item label="完成总天数" v-if="formData.type == 21">{{formData.complete_day}}</el-descriptions-item>
          <el-descriptions-item label="记得">{{reciteCount[10]}}</el-descriptions-item>
          <el-descriptions-item label="模糊">{{reciteCount[20]}}</el-descriptions-item>
          <el-descriptions-item label="忘记">{{reciteCount[30]}}</el-descriptions-item>
        </el-descriptions>
      </div>
      
      <el-table class="custom mt10" :data="questionList" border stripe v-if="questionList">
        <el-table-column label="答题">
          <template slot-scope="scope">
            <div v-if="scope.row.type == 20 || scope.row.type == 21" class="d-s-s d-c">
              <p class="d-s-s">{{ scope.row.question.question_id+'、' }}<span v-html="scope.row.question.question"></span></p><br>
              <div class="d-s-s d-r">
                <div v-for="(v, i) in scope.row.question.answer_images" :key="i">
                  <el-image v-if="i<2" class="imgw100" :src="v.file_path" fit="cover" :preview-src-list="[v.file_path]" alt="" />
                </div>
              </div>
            </div>
            <div v-else>
              <p v-if="answerType"><span>{{scope.row.question.question_id}}、【{{ answerType[scope.row.question.answer_type].name }}】</span><span v-html="scope.row.question.question"></span>({{ scope.row.question.score }}分)</p>
              <div v-if="scope.row.question.answer_type != 30">
                <p v-for="(v, i) in scope.row.question.answers" :key="i">{{ v.value }}、{{ v.name }}</p>
              </div>
              <p class="blue f14">正确答案：{{ scope.row.question.answer.toString() }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="用户答案">
          <template slot-scope="scope" v-if="scope.row">
            <div class="f14" v-if="scope.row.type == 20 || scope.row.type == 21">
              <p>背诵状态：{{ recite[scope.row.recite_status] }}</p>
            </div>
            <div class="f14" v-else>
              <p>用户答案：<span :class="scope.row.is_right?'blue':'red'">{{ scope.row.my_answer }}</span></p>
              <p>是否正确：<span :class="scope.row.is_right ? 'blue' : 'red'">{{ scope.row.is_right ? '对' : '错' }}</span></p>
              <p>得分：{{ scope.row.score }} <span class="red" v-if="formData.type == 60 && scope.row.question.answer_type == 30 && scope.row.pingfen_time==''">用户未打分</span></p>
              <p v-if="scope.row.create_time">答题时间：{{ scope.row.create_time }}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ShuatiLogApi from '@/api/study/shuati_log.js';
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {},
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
      questionList: [],
      answerType: [],
      recite: {10:'记得',20:'模糊',30:'忘记'},
      shuatiPlanCount: {10:{count:0,right:0}, 20:{count:0,right:0}, 30:{count:0,right:0}, 40:{count:0,right:0}},
      reciteCount: {10:0, 20:0, 30:0}
    };
  },
  props: ['is_open', 'selectModel'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData = this.selectModel;
    this.getLogList();
  },
  methods: {
    getLogList(){
      let self = this;
      ShuatiLogApi.getList({is_page:0, shuati_id:this.selectModel.shuati_id}, true)
      .then(res => {
          if (res.code == 1) {
            self.questionList = res.data.list;
            if ([10,11,12,13,14].indexOf(self.formData.type) !== -1){
              res.data.list.forEach(v => {
                self.shuatiPlanCount[v.answer_type].count++;
                if (v.is_right) self.shuatiPlanCount[v.answer_type].right++;
              });
              console.log(self.shuatiPlanCount);
            }else if ([20,21].indexOf(self.formData.type) !== -1){
              res.data.list.forEach(v => {
                self.reciteCount[v.recite_status]++;
              });
            }
            self.answerType = res.data.answer_type;
          }
        })
        .catch(error => {});
    },
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/shuati/part/Detail.vue